import { render, staticRenderFns } from "./GroupWrapperSubsection.vue?vue&type=template&id=27cbb86c&scoped=true"
import script from "./GroupWrapperSubsection.vue?vue&type=script&lang=js"
export * from "./GroupWrapperSubsection.vue?vue&type=script&lang=js"
import style0 from "./GroupWrapperSubsection.vue?vue&type=style&index=0&id=27cbb86c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../imported/work/site/src/project/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cbb86c",
  null
  
)

export default component.exports